import { type JanusCtx, type Row, handBack } from '../context.js';
import { type JanusInput } from '../janus.js';
import { postEffectConditions } from '../post-effect-conditions.js';
import { effectTargets } from '../is-target-valid-for-effect.js';

/** includes/functions/janus/rolls/regeneration_roll.php:regeneration_roll */
export function regenerationRoll(ctx: JanusCtx, input: JanusInput, ability: Row, caster: Row, targets: Row[]): void {
  const eligible = effectTargets(ctx, input, ability, caster, targets);
  if (!eligible) return;
  if (targets.length > 1 && !ctx.read.has(ability, 'aoe_type'))
    handBack('regeneration_roll:multi-target-visibility');
  for (const target of eligible) {
    postEffectConditions(ctx, input, ability, caster, target);
  }
}
